import { EMPTY_LIST } from '../../../constants/common'
import { CustomSelect } from '../../CustomSelect'
import { FormBody, FormFieldSelect } from '../../Form'
import { FormikField, FormikForm } from '../../Formik'
import { InputField } from '../../Input'
import { Container } from '../Container'

function FormikFields() {
  return (
    <>
      <Container label='Formik Field Input'>
        <FormikForm initialValues={{ input: '123' }} onSubmit={() => {}}>
          <FormBody
            actionsProps={{
              cancelProps: {
                onClick: () => {},
              },
            }}
            headerProps={{
              notifications: EMPTY_LIST,
            }}
          >
            <FormikField
              Component={InputField}
              fieldComponentProps={{
                label: 'input field',
              }}
              name='input'
            />
          </FormBody>
        </FormikForm>
      </Container>
      <Container label='Formik Field borderless Input, Select'>
        <FormikForm
          initialValues={{
            input: '123',
            select: { label: 'label 1', value: 'value 1' },
          }}
          onSubmit={() => {}}
        >
          <FormBody
            actionsProps={{
              cancelProps: {
                onClick: () => {},
              },
              withUpload: false,
            }}
          >
            <FormikField
              borderless
              Component={InputField}
              fieldComponentProps={{
                label: 'input field',
              }}
              name='input'
            />
            <FormikField
              showLabel
              Component={FormFieldSelect}
              Select={CustomSelect}
              buttonType='borderless'
              fieldComponentProps={{
                label: 'select field',
              }}
              name='select'
              options={[
                { label: 'label 1', value: 'value 1' },
                { label: 'label 2', value: 'value 2' },
                { label: 'label 3', value: 'value 3' },
              ]}
            />
          </FormBody>
        </FormikForm>
      </Container>
    </>
  )
}

export default FormikFields
